import React, { useState, useEffect } from 'react';
import { Col, Flex, Layout, Button, Form, Input } from 'antd';
import { Image } from 'antd';
import { Carousel } from 'antd';
import {
  LockOutlined,
  UserOutlined
} from '@ant-design/icons';
import { Segmented } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import useAuth from "../../hooks/useAuth";
import { useDispatch, useSelector } from 'react-redux';
import { sendOtpCode, setToken, setUser, ssoLogin } from '../../store/slices/auth';
import { message } from 'antd';
import { jwtDecode } from 'jwt-decode';
import { Spin } from 'antd';

const LoginScreen = () => {
  let navigate = useNavigate();
  const location = useLocation();
  const [radio, setRadio] = useState("Kullanıcı Bilgileri İle Giriş")
  const [otp, isOtp] = useState(false)
  const { login, loginWithOtp } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(false);
  const { loading: ssoLoading } = useSelector(state => state.auth);

  const dispatch = useDispatch();

  useEffect(() => {
    const handleSSOAuth = async () => {
      const searchParams = new URLSearchParams(location.search);
      const ssoToken = searchParams.get('token');

      if (ssoToken) {
        setLoading(true);
        try {
          const decoded = jwtDecode(ssoToken);
          const emailAddress = decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
          const nameIdentifier = decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"];
          const userData = decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata"];
          const name = decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"];

          if (decoded) {
            // SSO login işlemi
            const result = await dispatch(ssoLogin({ token: ssoToken })).unwrap();

            if (result?.success) {
              messageApi.success('SSO girişi başarılı.');
              dispatch(setToken(result?.payload))
              dispatch(setUser({ email: emailAddress, adName: nameIdentifier, personelNo: userData, fullName: name }))
              navigate('/Home', { replace: true });
            } else {
              messageApi.error('SSO girişi başarısız oldu.');
            }
          } else {
            dispatch(setUser({}))
            messageApi.error('SSO girişi başarısız oldu.');
          }
        } catch (error) {
          messageApi.error('SSO girişi başarısız oldu.');
        } finally {
          setLoading(false);
        }
      }
    };

    handleSSOAuth();
  }, [location.search, navigate, messageApi]);

  const onRadioChange = (e) => {
    isOtp(false)
    setRadio(e)
  }

  const onChange = async (otpCode) => {
    setLoading(true)
    await loginWithOtp(phone, otpCode).then(
      () => {
        setLoading(false)
        navigate("/Home")
        // WARNING: do not set any formik state here as formik might be already destroyed here. You may get following error by doing so.
        // Warning: Can't perform a React state update on an unmounted component. This is a no-op, but it indicates a memory leak in your application.
        // To fix, cancel all subscriptions and asynchronous tasks in a useEffect cleanup function.
        // github issue: https://github.com/formium/formik/issues/2430
      },
      () => {
        setLoading(false)
        messageApi.info("Lütfen bilgilerinizi kontrol ediniz.")
        // if (scriptedRef.current) {
        //     setStatus({ success: false });
        //     setErrors({ submit: err.message });
        //     setSubmitting(false);
        // }
      }
    );
  };
  const sharedProps = {
    onChange,
  };

  const onSubmit = async () => {
    setLoading(true)
    await login(username, password).then(
      () => {
        setLoading(false)
        navigate("/Home")
        // WARNING: do not set any formik state here as formik might be already destroyed here. You may get following error by doing so.
        // Warning: Can't perform a React state update on an unmounted component. This is a no-op, but it indicates a memory leak in your application.
        // To fix, cancel all subscriptions and asynchronous tasks in a useEffect cleanup function.
        // github issue: https://github.com/formium/formik/issues/2430
      },
      () => {
        setLoading(false)
        messageApi.info("Lütfen bilgilerinizi kontrol ediniz.")

        // if (scriptedRef.current) {
        //     setStatus({ success: false });
        //     setErrors({ submit: err.message });
        //     setSubmitting(false);
        // }
      }
    );
  };

  const sendOtp = () => {
    if (/^(?:\+90.?5|0090.?5|905|0?5)(?:[01345][0-9])\s?(?:[0-9]{3})\s?(?:[0-9]{2})\s?(?:[0-9]{2})$/.test(phone)) // true
    {
      dispatch(sendOtpCode({ phone: phone })).unwrap().then(result => {
        if (result?.success)
          isOtp(true)
        else {
          messageApi.info("Sistemde kayıtlı telefon numarası bulunamadı.")
        }
      }).catch(() => {
        messageApi.info("Sistemde kayıtlı telefon numarası bulunamadı.")
      })
    } else {
      messageApi.info("Telefon numarası formatı yanlış.")

    }

  }

  if (ssoLoading || loading) {
    return <Flex justify='center' align='center' vertical gap={'large'} style={{ paddingTop: 30 }}> <Spin /> </Flex>
  }


  return (
    <>
      {contextHolder}
      <Col span={24}>
        <Carousel style={{ padding: 10 }} >
          <div>
            <Image
              preview={false}
              src={require("../../assets/img/sütaski-banner.jpg")}
            />
          </div>
        </Carousel>

        <Flex justify='center' align='center' vertical gap={'large'} style={{ paddingTop: 30 }}>
          <Segmented value={radio} style={{ fontFamily: 'Roboto' }} options={["Kullanıcı Bilgileri İle Giriş", "Telefon Numarası İle Giriş"]} onChange={onRadioChange} />
          {radio == "Kullanıcı Bilgileri İle Giriş" && (
            <Form
              onFinish={onSubmit}
              name="basic"
              layout='vertical'
              style={{
                fontFamily: 'Roboto'
              }}
              labelCol={{
                span: 24,
              }}
              wrapperCol={{
                span: 24,
              }}
              initialValues={{
                remember: true,
              }}
              autoComplete="off"
            >
              <Form.Item
                label="Sütaş Kullanıcı Adı"
                name="username"
                rules={[
                  {
                    required: true,
                    message: 'Kullanıcı adı giriniz.',
                  },
                ]}
              >
                <Input
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  prefix={<UserOutlined className="site-form-item-icon" />}
                  placeholder="Kullanıcı Adı"
                />
              </Form.Item>

              <Form.Item
                label="Şifre"
                name="password"
                rules={[
                  {
                    required: true,
                    message: 'Şifre giriniz.',
                  },
                ]}
              >
                <Input
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  type="password"
                  placeholder="Şifre" />
              </Form.Item>



              <Form.Item
              >
                <Button type="primary" loading={loading} htmlType="submit">
                  Giriş
                </Button>
              </Form.Item>
            </Form>
          )}

          {radio == "Telefon Numarası İle Giriş" && !otp && (
            <>
              <p style={{ fontSize: 16, color: 'black', fontWeight: 'bold', fontFamily: 'Roboto' }}>Grup Sütaşkı'na giriş için Sütaş Grubu'nda kayıtlı telefon numaranızı giriniz.</p>
              <Input
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                maxLength={11}
                style={{ width: '20%' }} placeholder="0505*******" required />
              <Button type="primary" onClick={() => sendOtp()}>
                Kod Gönder
              </Button>
            </>
          )}
          {radio == "Telefon Numarası İle Giriş" && otp && (
            <>
              <p style={{ fontSize: 16, color: 'black', fontWeight: 'bold', fontFamily: 'Roboto' }}>Telefon Numaranıza İletilen 6 Haneli Kodu Giriniz</p>
              <Input.OTP  {...sharedProps} />
              <a style={{ color: '#109047', fontFamily: 'Roboto' }} onClick={() => sendOtp()}>Tekrar Gönder</a>
            </>
          )}
        </Flex>
      </Col>
    </>
  );
};
export default LoginScreen;